import modular from 'modujs'
import * as modules from './modules'
// import lottie from 'lottie-web'
import globals from './globals'
import { debounce } from './utils/tickers'
import { $html, $loaderIntro } from './utils/dom'
import { ENV, FONT, CUSTOM_EVENT, CSS_CLASS, VARS } from './config'
import { isFontLoadingAPIAvailable, loadFonts } from './utils/fonts'

const app = new modular({
    modules: modules,
})

window.onload = () => {
    const $style = document.getElementById('main-css')

    if ($style) {
        if ($style.isLoaded) {
            init()
        } else {
            $style.addEventListener('load', () => {
                init()
            })
        }
    } else {
        console.warn('The "main-css" stylesheet not found')
    }
}

function init() {
    globals()

    app.init(app)

    const setVW = () => {
        $html.style.setProperty('--vw', `${VARS.window.width * 0.01}px`)
    }

    setVW()

    const setVH = () => {
        $html.style.setProperty('--vh', `${VARS.window.height * 0.01}px`)
    }

    if(ENV.IS_MOBILE) {
        setVH()
    }

    window.addEventListener(
        'resize',
        () => {
            VARS.window.width = window.innerWidth
            setVW()
            if(ENV.IS_DESKTOP) {
                VARS.window.height = window.innerHeight
            }
        }
    )

    // Bind window resize event with default vars
    const resizeEndEvent = new CustomEvent(CUSTOM_EVENT.RESIZE_END)
    window.addEventListener(
        'resize',
        debounce(() => {
            window.dispatchEvent(resizeEndEvent)
        }, 200, false)
    )


    const introAnimation = new Promise(resolve => {
        // Loader lottie animation duration
        setTimeout(() => {
            resolve()
        }, 3000);
    })

    const fontsLoad = new Promise(resolve => {
        /**
         * Eagerly load the following fonts.
         */
        if (isFontLoadingAPIAvailable) {
            loadFonts(FONT.EAGER, ENV.IS_DEV).then((eagerFonts) => {
                $html.classList.add(CSS_CLASS.FONTS_LOADED)

                if (ENV.IS_DEV) {
                    console.group('Eager fonts loaded!', eagerFonts.length, '/', document.fonts.size)
                    console.group('State of eager fonts:')
                    eagerFonts.forEach((font) => console.log(font?.family, font?.style, font?.weight, font?.status/*, font*/))
                    console.groupEnd()
                    console.group('State of all fonts:')
                    document.fonts.forEach((font) => console.log(font?.family, font?.style, font?.weight, font?.status/*, font*/))
                    console.groupEnd()
                }
                resolve()
            })
        } else {
            resolve()
        }
    })

    Promise.all([introAnimation, fontsLoad]).then(() => {
        $html.classList.add(CSS_CLASS.LOADED)
        $html.classList.add(CSS_CLASS.READY)
        $html.classList.remove(CSS_CLASS.LOADING)

        window.dispatchEvent(new CustomEvent(CUSTOM_EVENT.READY))
    })
}
